export class GraphqlWebSocket extends WebSocket {
  constructor(address: string) {
    super(address, ['graphql-ws']);
  }
}
